// The plane a drag moves a product across. Mostly it is the floor's, at the
// height grabbed. A view within a few degrees of level, as the elevations
// are, would see a floor plane edge-on: the pointer's ray meets it far off or
// nowhere. There the drag is across an upright plane instead, square to the
// room and facing the camera as near as one can, which slides the product
// along a wall direction at its own height.
import * as THREE from 'three';

// A view looking down by less than this, about 10 degrees, is level enough
// that a floor plane is useless to it. Above it the floor plane is kept, as
// the 3D views look down by 22.6 degrees and an upright plane there would
// move products across the room diagonally. At 10 degrees a floor drag
// already moves a product 5.8 times as far in depth as the pointer moves on
// screen, so the switch also bounds that.
const LEVEL_VIEW = Math.sin((10 * Math.PI) / 180);

/**
 * @param {THREE.Vector3} viewDirection Which way the camera looks.
 * @param {THREE.Vector3} through The point grabbed.
 * @return {THREE.Plane} The plane to drag across, through that point.
 */
export const dragPlaneFor = (
    viewDirection: THREE.Vector3,
    through: THREE.Vector3
): THREE.Plane => {
    const direction = viewDirection.clone().normalize();
    if (Math.abs(direction.y) >= LEVEL_VIEW) {
        return new THREE.Plane().setFromNormalAndCoplanarPoint(
            new THREE.Vector3(0, 1, 0),
            through
        );
    }

    // Facing back along whichever floor axis the view looks along more.
    const normal =
        Math.abs(direction.x) > Math.abs(direction.z)
            ? new THREE.Vector3(-Math.sign(direction.x), 0, 0)
            : new THREE.Vector3(0, 0, -Math.sign(direction.z));

    return new THREE.Plane().setFromNormalAndCoplanarPoint(normal, through);
};
